import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { isPhoneValid } from "../../auth/helpers/phonenumber-validation-helper";
export function useProfileState() {
    const { user } = useSelector((state) => state.userState);
    const { control, formState: { errors, isValid }, handleSubmit: submitForm, register, getValues, } = useForm({
        mode: "all",
        defaultValues: {
            name: user.user?.name ?? "",
            surname: user.user?.surname ?? "",
            email: user.user?.email ?? "",
            phone_number: user.user?.cell_number ?? "",
        },
    });
    register("name", {
        required: { value: true, message: "Name is required" },
    });
    register("surname", {
        required: { value: true, message: "Surname is required" },
    });
    register("email", {
        required: { value: true, message: "Email is required" },
        pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Please enter a valid email-address",
        },
    });
    register("phone_number", {
        required: { value: true, message: "Phone number is required" },
        validate: {
            isValidPhone: (v) => {
                return isPhoneValid(v) ? true : "Please enter a valid phone number";
            },
        },
    });
    const canSubmit = useMemo(() => !!isValid, [isValid]);
    return useMemo(() => ({
        control,
        canSubmit,
        errors,
        register,
        submitForm,
        getValues,
    }), [control, canSubmit, errors, register, submitForm, getValues]);
}
